import { create } from 'zustand'
export interface RefreshFnStore {
  refreshFn: () => Promise<any>
  setRefreshFn: (fn: () => Promise<any>) => any
}

export const useRefreshFnStore = create<RefreshFnStore>((set) => ({
  refreshFn: () => Promise.resolve(),
  setRefreshFn: (fn: () => Promise<any>) => set({ refreshFn: fn }),
}))
